import { Component, OnInit, HostListener } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { constants } from "../../../utils/constants";
import { AccountService } from "../../../services/account.service";
import { ICompany } from "../../../models/account.model";
import { StepperService } from "../../../services/stepper.service";
import { IErrorAlert } from "../../../interfaces/error.interface";
import Swal from "sweetalert2";
import helpers from "src/app/utils/helpers";


@Component({
  selector: "app-create-company",
  templateUrl: "./create-company.component.html",
  styleUrls: ["../../auth.styles.css"],
})
export class CreateCompanyComponent implements OnInit {
  constants: any = constants;
  helpers: any = helpers;
  error: IErrorAlert = null;
  invalidRuc: IErrorAlert = { ...constants.alerts.invalidRuc, width: "auto" };
  loading = false;
  company: ICompany;
  form: FormGroup;

  capslock = { ...constants.alerts.capslock, width: 'auto'}
  capslockOn: boolean;
  

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    public _account: AccountService,
    public _stepper: StepperService
  ) {
    this.company = this._account.getCompanyData();
    this._stepper.setCurrent(1);
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      ruc: [
        this.company?.ruc,
        [
          Validators.required,
          Validators.pattern(constants.validations.numeric.pattern),
          Validators.minLength(11),
        ],
      ],
      name: [
        this.company?.name,
        [
          Validators.required,
          Validators.pattern(constants.validations.alphabetic.pattern),
        ],
      ],
      area: [
        this.company?.area,
        [
          Validators.required,
          Validators.pattern(constants.validations.alphabetic.pattern),
        ],
      ],
      address: [
        this.company?.address,
        [
         Validators.required,
         Validators.pattern(constants.validations.alphanumeric.pattern),
        ],
      ],
      email: [
        this.company?.email,
        [
          Validators.required,
          Validators.pattern(constants.validations.email.pattern),
        ],
      ],
      phone: [
        this.company?.phone.substring(3),
        [Validators.required, Validators.minLength(8)],
      ],
    });

    this.helpers.initFormListeners(this.form);

    this.form.get("ruc").valueChanges.subscribe((ruc) => {
      this.error = null;
      if (this.form.get("ruc").valid) {
        this.loading = true;
        this.anyAlert();
        this._account.getCompanyByRuc(ruc).subscribe(
          (company: ICompany) => {
            this.form.patchValue({
              name: company.name,
              area: company.area,
              address: company.address,
              email: company.email,
            });
            this.form.markAllAsTouched();
            this.error = null;
            this._account.validCompany = true;
            this.loading = false;
          },
          (err: IErrorAlert) => {
            this.error = { ...err, width: "auto" };
            this.form.patchValue({
              name: '',
              area: '',
              phone: '',
              address: '',
              email: '',
            });
            this.form.markAsUntouched();
            this._account.validCompany = false;
            this.loading = false;
          }
        );
      }
    });
  }

  continue() {
    this.loading = true;
    this.error = null;
    // Se actualiza informacion si se modificó
    this.form.value.phone = "519" + this.form.value.phone;
    this._account.setCompanyData({
      ...this._account.account.company,
      ...this.form.value,
    });
    this._account.verifyCompany(this.form.get("ruc").value).subscribe(
      (resp: any) => {
        
        this._router.navigate(["/create-account/admin"]);
      },
      (err) => {
        if (err.swal) {
          this.showExistingCompanyAlert(err);
        } else {
          this.error = { ...err, width: "auto" };
        }
        this.loading = false;
      }
    );
  }

  showExistingCompanyAlert(err: IErrorAlert) {
    Swal.fire({
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      showCloseButton: true,
      html: `<p class='alert-question secondary'>${err.message}</p>`,
      icon: "warning",
      confirmButtonText: "Ir al Login",
      customClass: {
        confirmButton: "confirm-button-class",
        closeButton: "close-button-class",
        icon: "warning-icon-class",
        popup: "existing-company-popup-class"
      },
    }).then((result) => {
      if (result.value) {
        this._account.reset();
        this._router.navigate(["/login"]);
      }
    });
  }

  onClickImputTel(e):void {
    
    if(e.target.selectionStart === 0){
      e.target.setSelectionRange(6,6);
     
      
    }
       
   
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if(event.key === 'CapsLock'){
      this.capslockOn = event.getModifierState("CapsLock");
      this.anyAlert();
    }
        
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    if(event.key === 'CapsLock'){
      this.capslockOn = event.getModifierState("CapsLock");
      this.anyAlert();
    }
        
  }
  
  anyAlert(): boolean {
    return (
      (helpers.invalidControl(this.form.get("ruc")) &&
      (  !this.form.get("ruc").errors.required) ||
      this.error !== null ||
      this.capslockOn ) &&
      !this.loading
    );
  }
}
